import { Step } from '../../components/cmx-stepper/cmx-stepper.component';
import { DISABLE_NAVIGATION, SET_ACTIVE_STEP, StepperActions, UPDATE_STEPS } from '../../actions/stepper-actions';
import { defaultStepsRoutes } from '../../../shared/repositories/routes.repo';
import { OrderBuilderActions, RESET_BUILDER } from '../../actions/order-builder.actions';

/**
 * Records the structure and user's current position in a linear workflow
 */
export interface StepperState {
  steps: Step[];
  /** Active step index, 0-based */
  activeStep: number;
  disableNavigation: boolean;
}

/**
 * Configuration of steps and starting point for the order-builder workflow.
 * @type {{steps: {name: string}[]; activeStep: number; disableNavigation: boolean}}
 */
export const intialStepperState: StepperState = {
  steps: defaultStepsRoutes,
  activeStep: null,
  disableNavigation: true,
};

/**
 * Store state replacements by action
 * @param {StepperState} state existing state
 * @param {StepperActions} action
 * @return {StepperState} the new state of the workflow stepper
 */
export const stepperReducer = (
  state: StepperState = intialStepperState,
  action: StepperActions | OrderBuilderActions,
): StepperState => {
  switch (action.type) {
    case UPDATE_STEPS: {
      return {
        ...state,
        steps: [...action.payload],
      };
    }
    case SET_ACTIVE_STEP: {
      return {
        ...state,
        activeStep: action.payload,
      };
    }
    case DISABLE_NAVIGATION: {
      return {
        ...state,
        disableNavigation: action.payload,
      };
    }
    case RESET_BUILDER: {
      return {
        ...intialStepperState,
      };
    }
    default: {
      return state;
    }
  }
};
